import { TransactionHistoryRequestModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryRequestModel";

export class MobiSimRegistrationRequestModel extends TransactionHistoryRequestModel {
  carrier?: Array<string>;
  code?: string;
  simType?: number;
  fromDate?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  toDate?: string;
  package?: string;
  type?: number;
  created?: Record<string, unknown>[];
  userRef?: Array<string>;
  partnerCodes?: Array<string>;
  isdnOrIccid?: string;
  isOnlyStore?: string;
  order?: string;
  storeCodes?: Array<string>;
  serviceCode?: string;
  providerCode?: string;
  carrierCode?: Array<string>;
  packageCode?: Array<string>;
  serial?: string;
  transRef?: string;
  supplierRefCode?: string;
  constructor(data?: Partial<MobiSimRegistrationRequestModel>) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.limit = data?.limit;
    this.isdnOrIccid = data?.isdnOrIccid;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.package = data?.package;
    this.created = data?.created;
    this.simType = data?.simType;
    this.type = data?.type;
    this.storeCodes = data?.storeCodes;
    this.userRef = data?.userRef;
    this.partnerCodes = data?.partnerCodes;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
    this.serviceCode = data?.serviceCode;
    this.providerCode = data?.providerCode;
    this.carrierCode = data?.carrierCode;
    this.packageCode = data?.packageCode;
    this.serial = data?.serial;
    this.transRef = data?.transRef;
    this.supplierRefCode = data?.supplierRefCode;
  }
}
